import React from 'react'
import styles from './PME.module.css'
import WhiteSpace from '../../../WhiteSpace/WhiteSpace'

const PME = () => {
    return (
        <div className={styles.wrapper}>
            <div className={styles.container}>
                <div className={styles.titleWrapper}>
                    <img src="https://sazuli.pt/uploads/pme_lider_24.svg" alt="PME" />
                    <span className={styles.title}>
                        Certificado PME
                    </span>
                    <span className={styles.subtitle}>
                        Empresa certificada PME Líder 2024<br/>Reconhecida pela excelência e solidez financeira.
                    </span>
                </div>
                <div className={styles.imageWrapper}>
                </div>
            </div>
        </div>
    )
}

export default PME